import { Link } from '@inertiajs/react'
import { Check, CircleAlert } from 'lucide-react'
import { cn } from '@/lib/utils'
import { persistedUiParam } from '@/frontend/pages/Dashboard/AgentChats/runtime/assistantUiToggle'
import type { AgentChatParallelWorkSummary } from '@/frontend/pages/Dashboard/AgentChats/types'
import { AgentThinkingOrb } from '@/frontend/features/AgentChats/assistant-ui/components/AgentThinkingOrb'
import { useExecutionStatus } from '@/frontend/features/AgentChats/events/useExecutionStatus'

export function ParallelWorkLink({ work, workerId, sessionId, nested, testId, selected, onNavigate }: {
  work: AgentChatParallelWorkSummary
  workerId: string
  sessionId: string
  nested: boolean
  testId: string
  selected: boolean
  onNavigate?: () => void
}) {
  const status = useExecutionStatus(work.status, work.status_valid_until)
  const active = ['starting', 'running', 'watching', 'waiting', 'needs_user'].includes(status)
  const params = new URLSearchParams({ session_id: sessionId, background_run_id: work.run_id, background_turn_id: work.turn_id })
  const ui = persistedUiParam()
  if (ui) params.set('ui', ui)
  const label = active ? 'Em andamento' : status === 'unknown' ? 'Sem confirmação' : status === 'completed'
    ? (work.kind === 'subagent' ? 'Encerrado' : 'Concluído') : 'Interrompido'
  return (
    <Link
      href={`/dashboard/digital_workers/${workerId}/chat?${params.toString()}`}
      preserveScroll
      onClick={onNavigate}
      data-testid={testId}
      data-status={status}
      className={cn(
        'group/work relative flex min-w-0 items-center gap-2 rounded-md py-1 pr-2 text-[11.5px] text-muted-foreground transition-colors before:absolute before:bottom-1 before:top-1 before:w-px before:bg-border/80 hover:bg-accent/60 hover:text-foreground',
        nested ? 'pl-10 before:left-8' : 'pl-5 before:left-3',
        selected && 'bg-accent/60 text-foreground',
      )}
    >
      <span className="flex size-4 shrink-0 items-center justify-center">
        {active ? <AgentThinkingOrb label="Trabalho em paralelo" /> : status === 'completed'
          ? <Check aria-hidden="true" strokeWidth={1.75} className="size-3 text-success" />
          : <CircleAlert aria-hidden="true" strokeWidth={1.75} className="size-3 text-faint-foreground" />}
      </span>
      <span className="min-w-0 flex-1 truncate">{work.title}</span>
      <span className="shrink-0 text-[9.5px] text-faint-foreground">{label}</span>
    </Link>
  )
}
